import * as React from 'react';
import { Modal, ModalFooter, ScrollIntoView, Alert } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const SocialLoginModal = ({ isOpen , labels , onCancel , onCta , isCtaLoading , errorMessage ,  })=>{
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        title: labels.modalTitle,
        onModalClose: onCancel,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            onCancel: onCancel,
            onCta: onCta,
            ctaCaption: labels.yes,
            cancelCaption: labels.no,
            ctaLoading: isCtaLoading
        })
    }, errorMessage && /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: errorMessage
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "info",
        message: errorMessage
    })), /*#__PURE__*/ React.createElement("div", {
        className: "social-login-modal-content"
    }, /*#__PURE__*/ React.createElement(Text, null, labels.modalText), /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "info",
        message: labels.modalInfoText
    })));
};

export { SocialLoginModal };
//# sourceMappingURL=SocialLoginModal.js.map
